import type { RefCallback } from 'react';
import { useCallback, useState } from 'react';
import { useMountedState } from 'react-use';

export const useMatchContainer = (
  query: string
): [RefCallback<Element>, boolean] => {
  const [matches, setMatches] = useState(false);

  const isMounted = useMountedState();
  const refCallback = useCallback(
    (ref: Element) => {
      const mediaQueryList = ref.matchContainer(query);
      const onChange = () => {
        if (!isMounted()) {
          return;
        }
        setMatches(!!mediaQueryList.matches);
      };

      mediaQueryList.addEventListener('change', onChange);
      setMatches(mediaQueryList.matches);

      return () => {
        mediaQueryList.removeEventListener('change', onChange);
      };
    },
    [query, isMounted]
  );

  return [refCallback, matches];
};
